// 导出文件
export function exportFile(res, filename) {
  const blob = new Blob([res.data],{type: "application/vnd.ms-excel"});
  var downloadElement = document.createElement("a");
  var href = window.URL.createObjectURL(blob);
  downloadElement.href = href;

  if (filename) {
      downloadElement.download = filename;
  } else {
      filename = res.headers["content-disposition"];
      downloadElement.download = decodeURIComponent(filename.split("filename=")[1]);
  }

  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
  window.URL.revokeObjectURL(href);  
}

export function downloadFile(href, title) {
  let a = document.createElement('a');
  document.body.appendChild(a);
  a.href = href;
  a.download = title || '下载'
  a.click();
  document.body.removeChild(a)
}